import { render } from "./CarrierTruckUpdate.vue?vue&type=template&id=653190b6&scoped=true"
import script from "./CarrierTruckUpdate.vue?vue&type=script&lang=js"
export * from "./CarrierTruckUpdate.vue?vue&type=script&lang=js"

import "./CarrierTruckUpdate.vue?vue&type=style&index=0&id=653190b6&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-653190b6"]])

export default __exports__